import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { PreviousQuestionId } from '../../../domain';
import { QuestionType } from '../../../domain/models/question-type';
export var mapQuestionModelToQuestionImportInput = function mapQuestionModelToQuestionImportInput(question) {
  // Base mapping for common properties
  var nextQuestionId = question.nextQuestionId !== PreviousQuestionId.none.id.toString() ? question.nextQuestionId : null;
  var previousQuestionId = question.previousQuestionId !== PreviousQuestionId.none.id.toString() ? question.previousQuestionId : null;
  var baseProps = {
    id: question.id.toString(),
    description: question.description,
    type: question.type,
    index: question.index || 0,
    previousQuestionId: previousQuestionId,
    nextQuestionId: nextQuestionId,
    score: question.score,
    explanation: question.explanation
  }; // Switch case based on question type

  switch (question.type) {
    case QuestionType.Essay:
      {
        return baseProps;
      }

    case QuestionType.SingleChoice:
    case QuestionType.MultipleChoice:
      {
        var _singleMultipleChoice, _singleMultipleChoice2;

        var singleMultipleChoiceQuestion = question;
        return _objectSpread(_objectSpread({}, baseProps), {}, {
          answers: ((_singleMultipleChoice = singleMultipleChoiceQuestion.answers) === null || _singleMultipleChoice === void 0 ? void 0 : _singleMultipleChoice.map(function (answer) {
            var _answer$id;

            return {
              id: (_answer$id = answer.id) === null || _answer$id === void 0 ? void 0 : _answer$id.toString(),
              description: answer.description,
              files: []
            };
          })) || [],
          correctAnswers: ((_singleMultipleChoice2 = singleMultipleChoiceQuestion.correctAnswers) === null || _singleMultipleChoice2 === void 0 ? void 0 : _singleMultipleChoice2.map(function (correctAnswer) {
            var _correctAnswer$id;

            return {
              id: (_correctAnswer$id = correctAnswer.id) === null || _correctAnswer$id === void 0 ? void 0 : _correctAnswer$id.toString(),
              answerId: correctAnswer.answerId
            };
          })) || []
        });
      }

    case QuestionType.FillInBlank:
      {
        var _fillInBlankQuestion$, _fillInBlankQuestion$2;

        var fillInBlankQuestion = question;
        return _objectSpread(_objectSpread({}, baseProps), {}, {
          answers: ((_fillInBlankQuestion$ = fillInBlankQuestion.answers) === null || _fillInBlankQuestion$ === void 0 ? void 0 : _fillInBlankQuestion$.map(function (answer) {
            var _answer$id2;

            return {
              id: (_answer$id2 = answer.id) === null || _answer$id2 === void 0 ? void 0 : _answer$id2.toString(),
              description: answer.description,
              index: answer.index,
              files: []
            };
          })) || [],
          correctAnswers: ((_fillInBlankQuestion$2 = fillInBlankQuestion.correctAnswers) === null || _fillInBlankQuestion$2 === void 0 ? void 0 : _fillInBlankQuestion$2.map(function (correctAnswer) {
            var _correctAnswer$id2;

            return {
              id: (_correctAnswer$id2 = correctAnswer.id) === null || _correctAnswer$id2 === void 0 ? void 0 : _correctAnswer$id2.toString(),
              answerId: correctAnswer.answerId,
              score: correctAnswer.score
            };
          })) || []
        });
      }

    case QuestionType.Matching:
      {
        var _matchingQuestion$ans, _matchingQuestion$cor, _matchingQuestion$sub;

        var matchingQuestion = question;
        return _objectSpread(_objectSpread({}, baseProps), {}, {
          answers: ((_matchingQuestion$ans = matchingQuestion.answers) === null || _matchingQuestion$ans === void 0 ? void 0 : _matchingQuestion$ans.map(function (answer) {
            var _answer$id3;

            return {
              id: (_answer$id3 = answer.id) === null || _answer$id3 === void 0 ? void 0 : _answer$id3.toString(),
              description: answer.description,
              files: []
            };
          })) || [],
          correctAnswers: ((_matchingQuestion$cor = matchingQuestion.correctAnswers) === null || _matchingQuestion$cor === void 0 ? void 0 : _matchingQuestion$cor.map(function (correctAnswer) {
            var _correctAnswer$id3;

            return {
              id: (_correctAnswer$id3 = correctAnswer.id) === null || _correctAnswer$id3 === void 0 ? void 0 : _correctAnswer$id3.toString(),
              answerId: correctAnswer.answerId,
              subQuestionId: correctAnswer.subQuestionId,
              score: correctAnswer.score
            };
          })) || [],
          subQuestions: ((_matchingQuestion$sub = matchingQuestion.subQuestions) === null || _matchingQuestion$sub === void 0 ? void 0 : _matchingQuestion$sub.map(function (subQuestion) {
            return {
              id: subQuestion.id.toString(),
              description: subQuestion.description,
              index: subQuestion.index
            };
          })) || []
        });
      }

    default:
      throw new Error("Unsupported question type: ".concat(question.type));
  }
};